import { gql } from '@apollo/client';

export const DELETE_CURRICULUM_MUTATION = gql`
    mutation deleteCurriculum($curriculumID: UUID!) {
        result: deleteCurriculum(curriculumID: $curriculumID) {
            affectedRows
        }
    }
`;
